/** Mirrors App\Service\Analytics\AnalyticsManager::READY_EVENT. */
export const EPMS_ANALYTICS_READY_EVENT = "epms-analytics:ready";
/**
 * Runs the callback with window.epmsAnalytics now if it exists, otherwise as
 * soon as AnalyticsManager has created it. On desktop pages whose own bundle
 * loaded the webpack runtime first, that is only at DOMContentLoaded, so a
 * check on first render would miss it. Does nothing on portals without
 * analytics. Returns a function that cancels a callback still waiting.
 */
export function whenEpmsAnalyticsReady(callback) {
    if (!window.isEpmsAnalyticsFeatureEnabled) {
        return () => { };
    }
    if (window.epmsAnalytics) {
        callback(window.epmsAnalytics);
        return () => { };
    }
    const onReady = () => {
        if (window.epmsAnalytics) {
            callback(window.epmsAnalytics);
        }
    };
    document.addEventListener(EPMS_ANALYTICS_READY_EVENT, onReady, {
        once: true,
    });
    return () => document.removeEventListener(EPMS_ANALYTICS_READY_EVENT, onReady);
}
/** Dispatched on document by EpmsAnalytics when the visitor allows tracking. */
export const EPMS_ANALYTICS_CONSENT_EVENT = "epms-analytics:consent";
/**
 * whenEpmsAnalyticsReady() for an event reported once: send returns whether
 * it was delivered, and one dropped for missing consent is sent again if the
 * visitor allows tracking on this page. Returns a function that cancels both.
 */
export function sendWhenEpmsAnalyticsAllows(send) {
    let removeConsentListener = () => { };
    const cancelReady = whenEpmsAnalyticsReady((analytics) => {
        if (send(analytics)) {
            return;
        }
        const onConsent = () => send(analytics);
        document.addEventListener(EPMS_ANALYTICS_CONSENT_EVENT, onConsent, {
            once: true,
        });
        removeConsentListener = () => document.removeEventListener(EPMS_ANALYTICS_CONSENT_EVENT, onConsent);
    });
    return () => {
        cancelReady();
        removeConsentListener();
    };
}
